<header class="col-12 header-page row">
  <h1 class="px-0 col-xl-10 header__page__content__title">
    Histórico das Declarações
  </h1>
  <div class="col-xl-2 col-lg-4 col-md-5 col-sm-12 px-0 header__button__historico">
    <a type="button" [routerLink]="['/solicitacao-declaracao-ppe']" class="btn btn-outline-primary col-10 float-right">
      <span>Voltar</span>
    </a>
  </div>
</header>
<ng-template #naoPossuiDeclaracoes>
  <p class="ng-template-text">Você não possui declarações!</p>
</ng-template>
<main class="main__content" *ngIf="statementHistory?.items.length > 0 else naoPossuiDeclaracoes">
  <section class="content__header__page">
    <h2>
    </h2>
    <filtro-dados [pageItens]="5" [totalItens]="statementHistory?.totalItems"
      (changeQuantidade)="onChangeQuantidadeItens($event)"
      *ngIf="statementHistory && statementHistory.items.length > 0">
    </filtro-dados>
  </section>
  <section class="content__main">
    <div class="d-flex content__header__table">
      <div class="col-xl-4">Data/Hora solicitação</div>
      <div class="col-xl-4">Validade da Declaração</div>
      <div class="col-xl-3">Politicamente Exposto</div>
      <div class="col-xl-1 text-center">Ações</div>
    </div>
    <div class="table__card" *ngFor="let pessoa of statementHistory?.items">
      <div class="col-xl-4">{{pessoa.issueDate | date: 'dd/MM/yyyy'}}</div>
      <div class="col-xl-4">{{pessoa.expirationDate | date: 'dd/MM/yyyy'}}</div>
      <div class="col-xl-3">{{pessoa.politicallyExposed == true ? 'Sim' : 'Não'}}</div>
      <div class="col-xl-1">
        <fa-icon class="fa-icon" [icon]="faDownload" (click)="download(pessoa.code)"></fa-icon>
      </div>
    </div>
  </section>
</main>
<footer class="col-12 footer__content">
  <paginacao [currentPage]="1" [collectionSize]="statementHistory?.totalItems" [pageSize]="filter?.ItemsPerPage"
    (changeNumber)="onChangePagination($event)" *ngIf="statementHistory?.items.length > 0">
  </paginacao>
  <!-- <button type="button" [routerLink]="['/solicitacao-declaracao-ppe']" class="btn btn-primary col-xl-1 col-lg-4 col-md-5 col-sm-12 px-0 float-right"
    >
    <span >Voltar</span>        
  </button> -->
</footer>